import type { CompanyFeature } from 'app/config/company.config';
import { COMPANY_FEATURES } from 'app/config/company.config';
import type { Feature } from 'app/config/features.config';
import { FEATURES_SWITCH } from 'app/config/features.config';
import type { UserFeature } from 'app/config/permissions.config';
import { USER_PERMISSIONS } from 'app/config/permissions.config';

import { isNumber } from './numbers';

const isCommonFeature = (feature: string): feature is Feature =>
  !!FEATURES_SWITCH?.[feature as Feature];

const hasAccess = (allowedUserTypes: UserType[], currentUserType: UserType): boolean =>
  allowedUserTypes.includes(currentUserType);

const hasAccessToFeature = (feature: Feature, currentUserType: UserType): boolean => {
  const featurePermissions = FEATURES_SWITCH[feature];
  if (featurePermissions.length === 0) {
    return false;
  }
  return (featurePermissions as string[]).includes(currentUserType);
};

const hasAccessToFeatures = (features: Feature[], currentUserType: UserType): boolean =>
  features.some(feature => hasAccessToFeature(feature, currentUserType));

const companyHasAccessToFeature = (feature: CompanyFeature, currentCompanyId: number): boolean => {
  const value = COMPANY_FEATURES[feature].value.includes(currentCompanyId);

  return COMPANY_FEATURES[feature].type === 'ALLOWED' ? value : !value;
};

const userHasAccessToFeature = (feature: UserFeature, userId: number | undefined): boolean =>
  isNumber(userId) && USER_PERMISSIONS[feature].includes(userId);

export {
  hasAccess,
  hasAccessToFeature,
  hasAccessToFeatures,
  companyHasAccessToFeature,
  isCommonFeature,
  userHasAccessToFeature
};
